"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Adyen = require("@reverbdotcom/adyen-cse-js");
var moment = require("moment");
var app_config_store_1 = require("../reverb-js-common/app_config_store");
var TOKENIZATION_PARAMS = [
    'number',
    'cvc',
    'holderName',
    'expiryMonth',
    'expiryYear',
];
// our expiration year input is 2 numbers but adyen wants 4 for tokenization
var formatExpirationYear = function (yearString) {
    var date = moment(yearString, 'YY');
    return date.format('YYYY');
};
// according to adyen this should be generated server-side
var generationTime = function () {
    return new Date().toISOString();
};
var formattedTokenizationData = function (data) {
    var formattedData = {};
    TOKENIZATION_PARAMS.forEach(function (key) {
        if (data[key]) {
            if (key === 'expiryYear' && data[key].length === 2) {
                formattedData[key] = formatExpirationYear(data[key]);
            }
            else {
                formattedData[key] = data[key];
            }
        }
    });
    formattedData.generationtime = generationTime();
    return formattedData;
};
var options = {};
var tokenizeCard = function (creditCardData) {
    var adyenClientEncryptionPublicKey = app_config_store_1.default.getState().adyenClientEncryptionPublicKey;
    var adyen = Adyen.createEncryption(adyenClientEncryptionPublicKey, options);
    return adyen.encrypt(formattedTokenizationData(creditCardData));
};
exports.tokenizeCard = tokenizeCard;
exports.default = { tokenizeCard: tokenizeCard };
//# sourceMappingURL=adyen_tokenization.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/credit_cards/adyen_tokenization.js
// module id = azg/
// module chunks = 20 21